export default __webpack_public_path__ + "static/media/wd-40.12ad9eed.png";